/**
 * The send status to show for a campaign row.
 *
 * `Campaign.status` is not advanced after scheduling yet (B3), so a campaign
 * that went out still reads "scheduled". The send counter is. Real terminal and
 * in-progress statuses are kept, so this stays right once B3 lands. Shared by
 * the Dashboard and the Campaign report so the two never disagree.
 */
export function displayStatus(campaign: { status: string; sent: number }): string {
  if (campaign.status === "draft" || campaign.status === "halted" || campaign.status === "sending" || campaign.status === "sent") {
    return campaign.status;
  }
  return campaign.sent > 0 ? "sent" : campaign.status;
}

/**
 * A campaign's status rendered as a colour, not just a word (#261).
 *
 * `halted` is the one an operator must not scan past: it means a send crossed an
 * alert threshold and stopped mid-flight with part of the list mailed. Letting
 * it render in the same neutral grey as `sent` is how a halted edition sits
 * unnoticed on the landing page for a day.
 */
export const CAMPAIGN_STATUS_CLASS: Record<string, string> = {
  sent: "p-good",
  sending: "p-accent",
  scheduled: "p-warn",
  halted: "p-crit",
  draft: "p-neutral",
};
